import { Text, View } from "@react-pdf/renderer";
//import { styles } from "../styles";
import { RangeView } from "../firstPageComponents/range";

import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { object } from "zod";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale("pt-br");
const TIMEZONE = "America/Sao_Paulo";

export const RfoFirstPage = ({
	relatorio,
	sharedOptions,
	rfos,
	totalTickets,
}) => {
	console.log("relatorio", relatorio);
	return (
		<View style={styles.firsPageContainer}>
			<RangeView sharedOptions={sharedOptions} />
			<Text
				style={{
					fontSize: 12,
					textAlign: "justify",
					fontFamily: "Times-Roman",
					lineHeight: 1.5,
				}}
			>
				{`Total de RFOs no Período: ${totalTickets}`}
			</Text>
			<Text
				style={styles.stylesReportIntro.clientTitle}
			>{`Cliente : ${relatorio?.client?.toUpperCase()}`}</Text>
			<Text
				style={[styles.text, { textIndent: "20px" }]}
			>{`O presente relatório reúne os Registros de Falha e Ocorrência (RFO) identificados e tratados no ambiente monitorado, referentes ao cliente ${relatorio?.client?.toUpperCase()}, abrangendo o período de ${
				sharedOptions?.dataInicial + " " + sharedOptions?.horaInicial
			} a ${
				sharedOptions?.dataFinal + " " + sharedOptions?.horaFinal
			}. Este documento tem como objetivo apresentar, de forma clara e organizada, as ocorrências registradas, suas respectivas causas e as soluções adotadas para para garantir a continuidade dos serviços afetados.`}</Text>

			<Text
				style={[styles.stylesReportIntro.clientTitle, { marginTop: "12px" }]}
			>
				{`Atendimentos Por Serviço:`}
			</Text>
			{Array.isArray(Object?.keys(rfos)) &&
				Object?.keys(rfos)?.length > 0 &&
				Object?.keys(rfos)?.map((key, i) => (
					<View key={key} style={styles.stylesReportIntro.viewer}>
						{rfos?.[key]?.map((rfo, index) => (
							<View
								key={index}
								style={[
									styles.stylesReportIntro.viewer,
									{ pageBreakInside: "avoid" },
								]}
								wrap={false}
							>
								{i > 0 && index < 1 && (
									<View
										style={[
											styles.divider,
											{
												marginVertical: "0px",
												marginTop: "12px",
												height: 2,
												color: "black",
											},
										]}
									/>
								)}
								{index < 1 && <Text style={styles.subtitle}>{`${key}:`}</Text>}
								{index > 0 && (
									<View
										style={[
											styles.divider,
											{ marginLeft: "20px", width: "483px" },
										]}
									/>
								)}
								<View style={styles.table}>
									<View style={styles.column}>
										<Text style={styles.textBold}>Protocolo:</Text>
										<Text style={styles.text}>{rfo?.protocolo}</Text>
									</View>

									<View style={styles.column}>
										<Text style={styles.textBold}>Status:</Text>
										<Text style={styles.text}>{rfo?.status}</Text>
									</View>
								</View>

								{rfo?.data_cadastro && (
									<View style={styles.table}>
										<View style={styles.column}>
											<Text style={styles.textBold}>Data de Cadastro:</Text>
											<Text style={styles.text}>
												{dayjs(rfo?.data_cadastro)
													?.tz(TIMEZONE)
													?.format("DD/MM/YYYY HH:mm:ss")}
											</Text>
										</View>
										<View style={styles.column}>
											<Text style={styles.textBold}>Data de Fechamento:</Text>
											<Text style={styles.text}>
												{!!rfo?.data_fechamento
													? dayjs(rfo?.data_fechamento)
															?.tz(TIMEZONE)
															?.format("DD/MM/YYYY HH:mm:ss")
													: "-"}
											</Text>
										</View>
									</View>
								)}
								<View style={styles.table}>
									{rfo?.causeProblem && (
										<Text style={styles.textBold}>Causa Identificada: </Text>
									)}
								</View>
								<View style={styles.table}>
									{rfo?.causeProblem && (
										<Text style={[styles.text, { textIndent: "20px" }]}>
											{rfo?.causeProblem}
										</Text>
									)}
								</View>
								<View style={styles.table}>
									{rfo?.solutionProblem && (
										<Text style={styles.textBold}>Solução Aplicada: </Text>
									)}
								</View>
								<View style={styles.table}>
									{rfo?.solutionProblem && (
										<Text style={[styles.text, { textIndent: "20px" }]}>
											{rfo?.solutionProblem}
										</Text>
									)}
								</View>
							</View>
						))}
					</View>
				))}
			{relatorio?.observacoes && (
				<View
					style={{
						...styles.metricsInColumn,
						marginTop: 10,
						padding: 10,
						backgroundColor: "#f5f5f5",
						borderRadius: 4,
						width: "100%",
					}}
					wrap
				>
					<Text
						style={{
							fontSize: 12,
							fontFamily: "Times-Bold",
							marginBottom: 5,
							color: "#000000",
						}}
					>
						Observações:
					</Text>

					<Text
						style={{
							fontSize: 12,
							textAlign: "justify",
							fontFamily: "Times-Roman",
							lineHeight: 1.5,
							width: "100%",
						}}
					>
						{relatorio.observacoes}
					</Text>
				</View>
			)}
		</View>
	);
};

const styles = {
	divider: {
		width: "100%",
		height: 1,
		backgroundColor: "#ccc",
		marginVertical: 8,
	},
	table: {
		display: "flex",
		flexDirection: "row",
		width: "100%",
		paddingLeft: "20px",
	},
	column: {
		width: "50%",
		textAlign: "justify",
		flexDirection: "row",
		flexWrap: "noWrap",
		gap: "4px",
	},
	title: {
		fontSize: 14,
		textAlign: "justify",
		fontFamily: "Times-Bold",
		color: "#212B36",
		marginVertical: 10,
	},
	subtitle: {
		fontSize: 12,
		textAlign: "justify",
		color: "#212B36",
		fontFamily: "Times-Bold",
		marginVertical: 10,
	},
	text: {
		fontSize: 12,
		textAlign: "justify",
		fontFamily: "Times-Roman",
		lineHeight: 1.5,
	},
	textBold: {
		fontSize: 12,
		textAlign: "justify",
		fontFamily: "Times-Bold",
		lineHeight: 1.5,
		textAlign: "justify",
	},
	legend: {
		fontSize: 10,
		fontFamily: "Times-Roman",
		maxWidth: "90%",
	},
	legendBold: {
		fontSize: 10,
		fontFamily: "Times-Bold",
	},
	firsPageContainer: { display: "flex", flexDirection: "column" },
	stylesReportIntro: {
		viewer: {
			display: "flex",
			flexDirection: "column",
			gap: "0px",
		},
		clientTitle: {
			fontSize: 14,
			textAlign: "justify",
			fontFamily: "Times-Bold",
			color: "#212B36",
			marginBottom: 5,
		},
		rowView: {
			display: "flex",
			flexDirection: "row",
			flexWrap: "noWrap",
			textAlign: "justify",
			gap: "4px",
		},
	},
};
